module.exports = __webpack_public_path__ + "assets/img/conversion_coin.6b42f69e.png";